//admin routes
import errorRoutes from "@/views/admin/errors/routes";
import applicationRoutes from "@/views/admin/applications/routes";
import roleRoutes from "@/views/admin/roles/routes";
import languageRoutes from "@/views/admin/languages/routes";
import officeRoutes from "@/views/admin/offices/routes";
import testingRoutes from "@/views/admin/testing/routes";
import testingStructureRoutes from "@/views/admin/testingStructure/routes";
import questionRoutes from "@/views/admin/questions/routes";
import stateRoutes from "@/views/admin/states/routes";
import eventRoutes from "@/views/admin/events/routes";
import homeRoutes from "@/views/admin/Home/routes";
import nrkRoutes from "@/views/admin/nrk/routes";
import emailRoutes from "@/views/admin/email/routes";
import candidateRoutes from "@/views/admin/candidates/routes";
import settingsRoutes from "@/views/admin/settings/routes";
import userRoutes from "@/views/admin/users/routes";
import reportRoutes from "@/views/admin/reports/routes";
import attestationRoutes from "@/views/admin/attestation/routes";


//candidate routes
import testRoutes from "@/views/candidate/testing/routes";
import mrkRoutes from "@/views/admin/mrk/routes";
import demoRoutes from "../views/admin/demo/routes";


const adminRoutes = [
    ...homeRoutes,
    ...errorRoutes,
    ...applicationRoutes,
    ...roleRoutes,
    ...languageRoutes,
    ...officeRoutes,
    ...testingRoutes,
    ...testingStructureRoutes,
    ...questionRoutes,
    ...stateRoutes,
    ...eventRoutes,
    ...nrkRoutes,
    ...emailRoutes,
    ...candidateRoutes,
    ...settingsRoutes,
    ...userRoutes,
    ...reportRoutes,
    ...attestationRoutes,
    ...mrkRoutes,
    ...demoRoutes
];

const candidateTestingRoutes = [
    ...testRoutes,
];

const routeArrays = {
    admin: adminRoutes,
    candidate: candidateTestingRoutes
};


export default routeArrays;
